import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OfertasPackListComponent } from './ofertas-pack-list/ofertas-pack-list.component';


const routes: Routes = [

    { path: '', component: OfertasPackListComponent  },
    { path: 'edit/:id', component: OfertasPackListComponent },
    { path: 'crear', component: OfertasPackListComponent }, 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppOfertasPacksRoutingModule {}
